import React from 'react';
import AiWorkspace from '../../components/ai/AiWorkspace';
import { Box } from '@mui/material';
import AssistantChecklistSection from '../../components/assistant/AssistantChecklistSection';

export default function AssistantPage() {
  return (
    <Box sx={{ p: { xs: 0, sm: 0 } }}>
      <AiWorkspace />
      <AssistantChecklistSection mode="page" />
    </Box>
  );
}